module.exports = __webpack_public_path__ + "media/images/icon_work_article01_on-6a57d186935f57fc6b9492354bb267c8.svg";